// extracted by mini-css-extract-plugin
export var bold = "bold-IPV";
export var button_container = "button_container-Pbc";
export var callout = "callout-j8u";
export var container = "container-yYb";
export var data_viz = "data_viz-l8k";
export var embedded_entry = "embedded_entry-SJ8";
export var image_container = "image_container-aaV";
export var italic = "italic-5xg";